
import AppModal from "@/components/AppModal";
import {Divider, Stack, Typography,Box, useTheme} from "@mui/material";
import mobileClasses from "./mobile.module.css";
import RpIcon from "@/components/RpIcon";
import React, {useEffect, useState} from "react";
import {useBoolean, useRequest} from "ahooks";
import AppLoadingButton from "@/components/mui/LoadingButton";
import {useSelector} from "react-redux";
import { applyCard } from '@/services/card'
import {useNavigate} from "react-router-dom";
import RouteConstant from "@/constant/RouteConstant";
import {CARD_STRING_TYPE as CARD_TYPE, KYC_STATUS} from "@/constant/Constant";
import {useTranslation} from "react-i18next";
import VarietySelectModal from "@/pages/components/VarietySelectModal";
import { ERROR_CODE } from "@/constant/ErrorConstant";
import axiosInstance from "@/utils/axios";
import API from "@/constant/API";
import { enqueueSnackbar, closeSnackbar } from "notistack"
import {getUAInfo} from "@/utils/utils";
import {useConfirm} from "material-ui-confirm";
const PaymentModal = (props) => {
  const { open, onClose, paymentInfo, cardBinSn, couponCode, onPay, previewRes } = props;
  const { shippingAddress } = useSelector((state) => state.card);
  const theme = useTheme()
  const navigate = useNavigate();
  const { t } = useTranslation()
  const confirm = useConfirm()
  const [varietySelectModalOpen, varietySelectModalOpenOperate] = useBoolean(false);
  const [selectedVariety, setSelectedVariety] = useState(null);
  const {homeInfo} = useSelector((state) => state.user);

  const applyCardReq = useRequest(async() => {
    let postData = {
      cardBinSn: cardBinSn.sn,
      couponCode: couponCode,
    }
    if (cardBinSn.cardType === CARD_TYPE.PHYSICAL) {
      postData = {
        ...postData,
        cardShippingAddressSn: shippingAddress.sn,
      };
    }
    const res = await applyCard(postData)
  }, { manual: true })

  const doBuyCard = () => {
    applyCardReq.runAsync().then((res) => {
      onClose && onClose()
      navigate(`${RouteConstant.SUCCESS}?source=buy_card`);
    })
    .catch(e => {

      // confirm({
      //   title: t('risk_safety_tips'),
      //   description: t('risk_safety'),
      //   confirmationText: t('go_to_app_verify'),
      //   hideCancelButton: true,
      // }).then(result => {
      //   const ua = getUAInfo()
      //   const { os, browser } = ua

      //   if (os?.name.toLowerCase() == 'ios' || os?.name.toLowerCase() == 'macos') {
      //     window.open('https://apps.apple.com/app/id6449689356')
      //   }
      //   if (os?.name.toLowerCase() == 'android') {
      //     window.open('https://play.google.com/store/apps/details?id=com.redotpay')
      //   }
      // })
      // return

      // enqueueSnackbar(e.msg || t("request_exception"), { variant: 'error' })
      // if (e?.code == ERROR_CODE.NEED_LIVE_DETECT) {
      //   // onClose?.();
      //   _checkRiskControl();
      // }
    })
  }

  // const _checkRiskControl = async () => {

  //   const res = await axiosInstance.post(API.LIVE_DETECT);
  //   if (res.isRisk == 1) {
  //     confirm({
  //       title: t('risk_safety_tips'),
  //       description: t('risk_safety'),
  //       confirmationText: t('go_to_app_verify'),
  //       hideCancelButton: true,
  //     }).then(result => {
  //       const ua = getUAInfo()
  //       const { os, browser } = ua
  //       if (os?.name.toLowerCase() == 'ios') {
  //         window.open('https://apps.apple.com/app/id6449689356')
  //       }
  //       if (os?.name.toLowerCase() == 'android') {
  //         window.open('https://play.google.com/store/apps/details?id=com.redotpay')
  //       }
  //     })
  //   }
  // }

  const doDeposit = () => {
    varietySelectModalOpenOperate.setTrue()
  }

  const onVarietySelected = (variety) => {
    setSelectedVariety(variety)
    navigate(`${RouteConstant.USER_DEPOSIT}?variety_code=${variety.varietyCode}`)
  }

  return (<>
    <AppModal
      open={open}
      onClose={onClose}
    >
      <Stack className={mobileClasses.modal}>
        <Stack direction="row" alignItems="center" className={mobileClasses.modalHeader}>
          <Box onClick={() => { onClose() }}><RpIcon icon={'close'} size={18} /></Box>
          <Typography className={mobileClasses.modalTitle}>{
            paymentInfo.error ? t('deposit') : t('payment')
          }</Typography>
        </Stack>
        {!paymentInfo.error &&
          <Stack  className={mobileClasses.modalContent}>
          <Stack sx={{height: '72px'}} direction="row" alignItems="center" justifyContent="space-between">
            <Stack>
              <Box component="div">
                <span className={'h1'}>{paymentInfo?.bizAmount}</span>
                <span className={'h3'}> USD</span>
              </Box>
            </Stack>
            <img src={`/images/card/pay-review.svg`} width={'72'}/>
          </Stack>

          {
            paymentInfo?.results.map(_ => {
              const account = homeInfo?.assetUser?.accountList?.find(account => account.varietyCode == _.payVarietyCode);
              return (
                <Stack sx={theme => {
                  return { height: '72px',
                    border: `1px solid ${theme.palette.borderColor.divider}`,
                    padding: '16px',
                    borderRadius: '4px',
                    margin:'24px 0'
                  }
                }} direction="row" alignItems="center" justifyContent="space-between">
                  <Stack gap="12px" direction="row" alignItems="center">
                    <img src={`/images/coin/${_.payVarietyCode.toLowerCase()}.svg`}/>
                    <Stack>
                      <p className={'h5'}>{_.payVarietyCode?.toUpperCase()}</p>
                      {account?.available && <p>{t('available')}: {account?.available}</p>}
                    </Stack>
                  </Stack>
                  <Stack>
                    {/*<Typography>-{paymentInfo?.discount}</Typography>*/}
                    <Typography>- {_?.bizAmount}</Typography>
                  </Stack>
                </Stack>
              )
            })
          }

          <Stack
            sx={{marginTop: '16px'}}
          >
          <AppLoadingButton size={'large'} loading={applyCardReq.loading} onClick={doBuyCard} variant="contained">{t('pay')}</AppLoadingButton>
          </Stack>
        </Stack>}
        {paymentInfo?.error &&
          <Stack
            sx={{marginTop: '16px', padding: '16px'}}
          >
            <Stack direction="row" alignItems="center" justifyContent="center" gap="5px">
              <span>$</span>
              <Typography
                sx={{
                  fontWeight: 'bold',
                  padding: '16px 0',
                  color: theme.palette.text.primary,
                  fontSize: '32px',
                  textAlign: 'center'
                }}
              >{previewRes?.bizAmount}</Typography>
            </Stack>

            <Typography
              sx={{margin: '16px 0', textAlign: 'center'}}
              color="error">{paymentInfo?.error?.message}</Typography>
            <AppLoadingButton size={'large'} loading={applyCardReq.loading} onClick={doDeposit} variant="contained">{t('deposit')}</AppLoadingButton>
          </Stack>
          }
      </Stack>
    </AppModal>
    <VarietySelectModal open={varietySelectModalOpen}
                        varietyOperate={'deposit'}
                        onClose={varietySelectModalOpenOperate.setFalse}
                        onSelected={onVarietySelected}
    />
  </>)
}

export default PaymentModal;